import mixpanel from 'mixpanel-browser'

export class MixpanelService {
	static init() {
		mixpanel.init(import.meta.env.VITE_MIXPANEL)
	}

	static identify(userId: string): void {
		mixpanel.identify(userId)
	}

	static reset(): void {
		mixpanel.reset()
	}
}
